// import React, { useCallback, useEffect, useState, useRef } from "react";
// import { Form, Button } from "react-bootstrap";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import { useUser } from "../../../context/UserContext";
// import api from "../../../services/api";
// import useAuth from "../../../hooks/useAuth";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchAccountDetailsRequest,
//   fetchAccountInfoRequest,
// } from "../../../store/features/actions/accountsActions";
// import AccountDetailsTabsV2 from "./AccountDetailsTabsV2";
// import BenchmarkTabs from "./BenchmarkTabs";
// import "./Benchmarks.css";
// import * as FeatherIcon from "react-feather";
// import GenericOverviewSideCard from "../genericComponents/GenericOverviewSideCard";
// import AIChat from "../Chat/AiChat";
// import Card from "react-bootstrap/Card";
// import NotifyDropdown from "./RequiredModals/NotifyDropdown";
// import ExportModal from "./Exports/ExportModal";
// import WizardContainer from "./CreateBenchmarkWizard/WizardContainer";
// import {
//   submitOperationsAndSupplyChainFailure,
//   submitOperationsAndSupplyChainRequest,
// } from "../../../store/features/actions/operationsAndSupplyChainActions";
// import AddNewBenchmark from "./AddBenchmark/AddNewBenchmark";
// import CreateBenchmarkByNaturalLanguage from "./BenchmarkByNaturalLanguage/CreateBenchmarkByNaturalLanguage";
// import CreateBenchmarkByTemplateUpload from "./BenchmarkByTemplateUpload/CreateBenchmarkByTemplateUpload";
// import APP_CONFIG from "../../../config/appConfig";
// import "./ExportWrapper.css";
// import iq_api from "../../../services/iqApi";

// export default function Benchmarks() {
//   const dispatch = useDispatch();
//   useAuth();

//   const { user } = useUser();
//   const navigate = useNavigate();
//   const [showConversationModal, setShowConversationModal] = useState(false);
//   const { accountId, accountName, clientName } = useParams();
//   const [has_account_access, setHasAccountAccess] = useState(false);
//   const [current_benchmark_view, setBenchmarkView] = useState("data");
//   const [showMoreModal, setShowMoreModal] = useState(false);
//   const [open, setOpen] = useState(false);
//   const buttonRef = useRef(null);
//   const [activeParentTabKey, setParentActiveTab] = useState("corporateOrg");
//   const [createBenchmarkSection, setCreateBenchmarkSection] =
//     useState("showSteps");
//   const [sidecardTitleBlock, setSidecardTitleBlock] = useState([]);
//   const [displayUpdatesSection, setDisplayUpdatesSection] = useState(false);
//   const [showFormatDropdown, setShowFormatDropdown] = useState(false);
//   const [selectedFormat, setSelectedFormat] = useState(null);
//   const [showExportModal, setShowExportModal] = useState(false);
//   const [showAiInsights, setShowAiInsights] = useState(false);
//   const exportRef = useRef(null);
//   // useEffect(() => {
//   //   if (accountId && accountName && clientName) {
//   //     const params = {
//   //       page: 1,
//   //       limit: 1,
//   //       sort_by: "created_date",
//   //       order: "asc",
//   //       id: accountId,
//   //     };
//   //     // Check Account Access
//   //     dispatch(fetchAccountInfoRequest({ accountName, params }));
//   //     dispatch(fetchAccountDetailsRequest(accountId, accountName, clientName));
//   //   }

//   //   // End: Check Account Access
//   // }, [accountId, accountName, clientName]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (exportRef.current && !exportRef.current.contains(event.target)) {
//         setShowFormatDropdown(false);
//         setShowExportModal(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     let titleBlock = "";
//     if (createBenchmarkSection === "showSteps") {
//       titleBlock = (
//         <div className="mem-sc-titl-cont justify-content-between">
//           <div className="top_head_side_block">
//             <div className="top_side_guide">
//               <h5 className="top_head_side_guide">
//                 Choose Your Benchmark Creation Method
//               </h5>
//             </div>
//           </div>
//           <button
//             type="button"
//             className="btn-close"
//             aria-label="Close"
//             onClick={() => {
//               setCreateBenchmarkSection("showSteps");
//               setShowMoreModal(false);
//             }}
//           ></button>
//         </div>
//       );
//     } else if (createBenchmarkSection === "guidedSelection") {
//       titleBlock = (
//         <div className="mem-sc-titl-cont justify-content-between">
//           <div className="top_head_side_block">
//             <div
//               className="side_intial_block"
//               style={{ backgroundColor: "#7879F1" }}
//             >
//               <p className="side_intial">A</p>
//             </div>
//             <div className="top_side_guide">
//               <h5 className="top_head_side_guide">Guided Selection</h5>
//               <span className="span_memory">
//                 Create New Competitive Benchmark
//               </span>
//             </div>
//           </div>
//           <button
//             type="button"
//             className="btn-close"
//             aria-label="Close"
//             onClick={() => {
//               setCreateBenchmarkSection("showSteps");
//               setShowMoreModal(false);
//             }}
//           ></button>
//         </div>
//       );
//     } else if (createBenchmarkSection === "naturalLanguage") {
//       titleBlock = (
//         <div className="mem-sc-titl-cont justify-content-between">
//           <div className="top_head_side_block">
//             <div
//               className="side_intial_block"
//               style={{ backgroundColor: "#E66B91" }}
//             >
//               <p className="side_intial">B</p>
//             </div>
//             <div className="top_side_guide">
//               <h5 className="top_head_side_guide">Natural Language</h5>
//               <span className="span_memory">
//                 Create New Competitive Benchmark
//               </span>
//             </div>
//           </div>
//           <button
//             type="button"
//             className="btn-close"
//             aria-label="Close"
//             onClick={() => {
//               setCreateBenchmarkSection("showSteps");
//               setShowMoreModal(false);
//             }}
//           ></button>
//         </div>
//       );
//     } else if (createBenchmarkSection === "templateUpload") {
//       titleBlock = (
//         <div className="mem-sc-titl-cont justify-content-between">
//           <div className="top_head_side_block">
//             <div
//               className="side_intial_block"
//               style={{ backgroundColor: "#45A2E3" }}
//             >
//               <p className="side_intial">C</p>
//             </div>
//             <div className="top_side_guide">
//               <h5 className="top_head_side_guide">Template Upload</h5>
//               <span className="span_memory">
//                 Create New Competitive Benchmark
//               </span>
//             </div>
//           </div>
//           <button
//             type="button"
//             className="btn-close"
//             aria-label="Close"
//             onClick={() => {
//               setCreateBenchmarkSection("showSteps");
//               setShowMoreModal(false);
//             }}
//           ></button>
//         </div>
//       );
//     }
//     setSidecardTitleBlock(titleBlock);
//   }, [createBenchmarkSection]);

//   const handleFormatSelect = (format) => {
//     setSelectedFormat(format);
//     setShowFormatDropdown(false);
//     setShowExportModal(true);
//   };

//   const handleExport = (exportData) => {
//     console.log("Export triggered with:", exportData);
//     setShowExportModal(false);
//   };

//   const handleExportTemp = async () => {
//     let query = { client: "HB Fuller" };
//     try {
//       const res = await iq_api.get("/export_excel", {
//         params: query,
//         responseType: "blob", // This is important
//       });

//       // Create a blob from the response
//       const blob = new Blob([res.data], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });

//       // Create a download link
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;

//       // Set the download filename (optional)
//       a.download = "export.xlsx";
//       document.body.appendChild(a);
//       a.click();

//       // Clean up
//       window.URL.revokeObjectURL(url);
//       document.body.removeChild(a);
//     } catch (err) {
//       console.error("File download failed", err);
//     }
//   };

//   // const checkAccountAccess = useCallback(async () => {
//   //   try {
//   //     if (accountName && user?.role_key === "CLIENT") {
//   //       const response = await api.get("/accounts/check_account_access", {
//   //         params: {
//   //           account_name: accountName,
//   //         },
//   //       });

//   //       if (response.data.result.has_access === true) {
//   //         setHasAccountAccess(true);
//   //       } else {
//   //         setHasAccountAccess(false);
//   //         sessionStorage.setItem(
//   //           "errorMessage",
//   //           "Sorry. You don't have access for the account."
//   //         );
//   //         navigate("/dashboard");
//   //       }
//   //     }
//   //   } catch (err) {
//   //     console.log(err.message || "Failed to fetch events");
//   //   }
//   // }, [accountId, accountName, clientName]);

//   // useEffect(() => {
//   //   if (user?.role_key === "CLIENT") {
//   //     checkAccountAccess();
//   //   } else {
//   //     setHasAccountAccess(true);
//   //   }
//   // }, [checkAccountAccess, user]);

//   return (
//     <div>
//       {/* <div className="comp_bench_block">
//         <div className=" d-flex align-items-center justify-content-between">
//           <div className="comp_bench_left">
//             <h5 className="comp_head">Competitive Benchmarking</h5>
//             <p className="comp_para">
//               A side-by-side analysis of HB Fuller’s organizational model,
//               financial strategy, market presence, innovation pipeline, and
//               operational footprint compared to top healthcare supply
//               competitors curated for HB Fuller Health’s strategic intelligence
//               needs.
//             </p>
//           </div>
//           <div className="comp_bench_right">
//             <Button variant="dark" className="saved_bookmark">
//               {" "}
//               <img
//                 src="/img/pin.png"
//                 alt="image"
//                 className="filter_image mr-1"
//                 width="16"
//               />{" "}
//               Saved Benchmarks
//             </Button>
//             <Button
//               variant="dark"
//               className="new_benchmark"
//               onClick={(e) => {
//                 e.preventDefault();
//                 e.stopPropagation();
//                 setShowMoreModal(true);
//               }}
//             >
//               {" "}
//               <img
//                 src="/img/plus.png"
//                 alt="image"
//                 className="filter_image mr-1"
//                 width="16"
//               />{" "}
//               Create New Benchmark
//             </Button>
//           </div>
//         </div>
//       </div> */}

//       <div className="account_details_wrapper">
//         <div className="cardinal_wrapper">
//           <div className="cardinal_head_block">
//             <div className="cardinal_subblock">
//               <h5 className="cardinal_head">
//                 Competitive Benchmarking - {clientName}
//               </h5>
//               <p
//                 style={{
//                   fontWeight: "400",
//                   fontSize: "12px",
//                   lineHeight: "15px",
//                   color: "rgba(0, 0, 0, 0.6)",
//                   marginTop: "5px",
//                   marginBottom: "10px",
//                   maxWidth: "100%",
//                 }}
//               >
//                 Track {clientName ? clientName : ""}'s performance against key
//                 competitors across financial metrics, market share, and
//                 strategic positioning.
//               </p>
//             </div>

//             <div className="cardinal_btns">
//               {/* <div className="toggle_list_tableview">
//                 <Link
//                   className={`table_view ${
//                     current_benchmark_view === "data" ? "active" : ""
//                   }`}
//                   style={{
//                     fontSize: "12px",
//                     lineHeight: "15px",
//                     textDecoration: "none",
//                     padding: "7px 12px 7px 12px",
//                     // width: "56px",
//                     // height: "27px",
//                     radius: "8px",
//                   }}
//                   onClick={() => setBenchmarkView("data")}
//                 >
//                   Data View
//                 </Link>
//                 <Link
//                   className={`grid_view ${
//                     current_benchmark_view === "chart" ? "active" : ""
//                   }`}
//                   style={{
//                     fontSize: "12px",
//                     lineHeight: "15px",
//                     textDecoration: "none",
//                     padding: "7px 12px 7px 12px",
//                     // width: "56px",
//                     // height: "27px",
//                     radius: "8px",
//                   }}
//                   onClick={() => setBenchmarkView("chart")}
//                 >
//                   Chart View
//                 </Link>
//               </div> */}
//               {/* <Button variant="dark" className="saved_bookmark">
//                 {" "}
//                 <img
//                   src="/img/pin.png"
//                   alt="image"
//                   className="filter_image mr-1"
//                   width="16"
//                 />{" "}
//                 Saved Benchmarks
//               </Button> */}

//               {/* <a
//                 href="#"
//                 className="cardninal_href"
//                 onClick={() => setDisplayUpdatesSection((prev) => !prev)}
//               >
//                 New Updates <span className="count_update">15</span>
//               </a> */}

//               {/* <div
//                 className="export-wrapper"
//                 style={{ position: "relative" }}
//                 ref={exportRef}
//               >
//                 <a
//                   href="#"
//                   className="cardninal_href"
//                   onClick={() => {
//                     handleExportTemp();
//                   }}
//                 >
//                   Export{" "}
//                   <img
//                     src="/img/export_arrow.png"
//                     alt="image"
//                     className="cardinal_filter_img"
//                     width=""
//                   />
//                 </a>

//                 {showFormatDropdown && (
//                   <div className="export-dropdown">
//                     <div className="export_head">
//                       <p className="export_head_text">Export</p>
//                     </div>
//                     <div
//                       className="export_pdf_block"
//                       onClick={() => {
//                         setSelectedFormat("pdf");
//                         setShowExportModal(true);
//                         setShowFormatDropdown(false);
//                       }}
//                     >
//                       <div>
//                         <img
//                           src="/img/pdf.png"
//                           alt="image"
//                           className="export_icon"
//                           width=""
//                         />{" "}
//                         Export to .pdf
//                       </div>{" "}
//                       <div className="">
//                         <FeatherIcon.ChevronRight className="top_icons" />
//                       </div>
//                     </div>
//                     <div
//                       className="export_pdf_block"
//                       onClick={() => {
//                         setSelectedFormat("xls");
//                         setShowExportModal(true);
//                         setShowFormatDropdown(false);
//                       }}
//                     >
//                       <div>
//                         <img
//                           src="/img/xls.png"
//                           alt="image"
//                           className="export_icon"
//                           width=""
//                         />{" "}
//                         Export to .xls
//                       </div>{" "}
//                       <div className="">
//                         <FeatherIcon.ChevronRight className="top_icons" />
//                       </div>
//                     </div>
//                   </div>
//                 )}

//                 {showExportModal && (
//                   <ExportModal
//                     exportType={selectedFormat}
//                     categories={APP_CONFIG?.defaultCategories}
//                     onExport={handleExport}
//                     onBack={() => {
//                       setShowExportModal(false);
//                       setShowFormatDropdown(true);
//                     }}
//                   />
//                 )}
//               </div> */}

//               {/* <a
//                 href="#"
//                 className="cardninal_href"
//                 ref={buttonRef}
//                 onClick={() => setOpen(true)}
//               >
//                 Notify My Team{" "}
//                 <img
//                   src="/img/noitfy_my_team.png"
//                   alt="image"
//                   className="cardinal_filter_img"
//                   width=""
//                 />
//               </a> */}
//               {/* <a
//                 href="#"
//                 className="cardninal_href"
//                 // style={{ marginRight: "0" }}
//                 onClick={(e) => {
//                   e.preventDefault();
//                   e.stopPropagation();
//                   setShowConversationModal(true);
//                 }}
//               >
//                 {" "}
//                 <img
//                   src="/img/ai_sparkle.png"
//                   alt="image"
//                   className="cardinal_filter_img mr-1"
//                   width=""
//                 />{" "}
//                 AI Insight
//               </a> */}

//               <Button
//                 variant="dark"
//                 className="new_benchmark"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   e.stopPropagation();
//                   setShowMoreModal(true);
//                 }}
//               >
//                 {" "}
//                 <img
//                   src="/img/plus.png"
//                   alt="image"
//                   className="filter_image mr-1"
//                   width="16"
//                 />{" "}
//                 Create New Benchmark
//               </Button>
//             </div>
//           </div>
//         </div>
//         <div className="top_tabs_custom">
//           <BenchmarkTabs
//             displayUpdatesSection={displayUpdatesSection}
//             activeParentTabKey={activeParentTabKey}
//             setParentActiveTab={setParentActiveTab}
//           />
//         </div>

//         {/* <div className="fixed_req_block">
//           <h5 className="req_head">Request Submitted!</h5>
//           <p className="req_para">
//             Thank you for subscribing. Your access request is being processed.
//           </p>
//           <Button className="req_btn">
//             User Dashboard &nbsp;
//             <i className="fa fa-arrow-right" aria-hidden="true"></i>
//           </Button>
//         </div> */}
//       </div>

//       <NotifyDropdown
//         isOpen={open}
//         onClose={() => setOpen(false)}
//         anchorRef={buttonRef}
//       />

//       <GenericOverviewSideCard
//         showMoreModal={showMoreModal}
//         setShowMoreModal={setShowMoreModal}
//         titleForSideCard={sidecardTitleBlock}
//         comp={
//           createBenchmarkSection === "showSteps" ? (
//             <>
//               <AddNewBenchmark
//                 setCreateBenchmarkSection={setCreateBenchmarkSection}
//               />
//             </>
//           ) : createBenchmarkSection === "guidedSelection" ? (
//             <>
//               <WizardContainer />
//             </>
//           ) : createBenchmarkSection === "naturalLanguage" ? (
//             <>
//               <CreateBenchmarkByNaturalLanguage />
//             </>
//           ) : (
//             <>
//               <CreateBenchmarkByTemplateUpload />
//             </>
//           )
//         }
//         minWidthForDrawer="50%"
//         disableXbtn={true}
//       />

//       {/* <GenericOverviewSideCard
//         showMoreModal={showAiInsights}
//         setShowMoreModal={setShowAiInsights}
//         titleForSideCard={<h5>AI Insights</h5>}
//         comp={<div className="p-3">AI Insights</div>}
//         minWidthForDrawer="30%"
//         disableXbtn={true}
//       /> */}

//       {showConversationModal && (
//         <GenericOverviewSideCard
//           showMoreModal={showConversationModal}
//           setShowMoreModal={setShowConversationModal}
//           titleForSideCard={
//             <div className="ai_insight_top_block">
//               <div className="ai_insight_left">
//                 <div className="ai_insight_img">
//                   <img
//                     src="/img/ai_insight_top.png"
//                     alt="icon"
//                     className="ai_icon"
//                   />
//                 </div>
//                 <div className="ai_insight_text">
//                   <h5 className="ai_insight_top_head">
//                     Decode This: Tailored Chemical Products - Market Insights
//                   </h5>
//                   <p className="ai_insight_top_subhead">
//                     AI-powered competitive intelligence and strategic insights
//                   </p>
//                 </div>
//               </div>
//               <div className="ai_insight_right"></div>
//             </div>
//           }
//           comp={<AIChat section={""} />}
//           minWidthForDrawer="40%"
//           disableXbtn={false}
//         />
//       )}
//     </div>
//   );
// }

import React, { useCallback, useEffect, useState, useRef } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Table from "react-bootstrap/Table";
import { Form, Button } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useUser } from "../../../context/UserContext";
import api from "../../../services/api";
import useAuth from "../../../hooks/useAuth";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAccountDetailsRequest,
  fetchAccountInfoRequest,
} from "../../../store/features/actions/accountsActions";
import { submitCompetitorListRequest } from "../../../store/features/actions/competitorListActions";
import AccountDetailsTabsV2 from "./AccountDetailsTabsV2";
import BenchmarkTabs from "./BenchmarkTabs";
import "./Benchmarks.css";
import * as FeatherIcon from "react-feather";
import GenericOverviewSideCard from "../genericComponents/GenericOverviewSideCard";
import AIChat from "../Chat/AiChat";
import Card from "react-bootstrap/Card";
import NotifyDropdown from "./RequiredModals/NotifyDropdown";
import { fetchBenchmarkGenerationStatusRequest } from "../../../store/features/actions/benchmarkGenerationStatusActions";
import { displayFormattedDate } from "../../../services/commonService";
import ExportModal from "./Exports/ExportModal";
import WizardContainer from "./CreateBenchmarkWizard/WizardContainer";
import {
  submitOperationsAndSupplyChainFailure,
  submitOperationsAndSupplyChainRequest,
} from "../../../store/features/actions/operationsAndSupplyChainActions";
import AddNewBenchmark from "./AddBenchmark/AddNewBenchmark";
import CreateBenchmarkByNaturalLanguage from "./BenchmarkByNaturalLanguage/CreateBenchmarkByNaturalLanguage";
import CreateBenchmarkByTemplateUpload from "./BenchmarkByTemplateUpload/CreateBenchmarkByTemplateUpload";
import APP_CONFIG from "../../../config/appConfig";
import "./ExportWrapper.css";
import iq_api from "../../../services/iqApi";

import { submitCreateBenchmarkRequest } from "../../../store/features/actions/createBenchmarkActions";
import CompetitorsNew from "./CreateBenchmarkWizard/CompetitorsNew";

export default function Benchmarks() {
  const dispatch = useDispatch();
  useAuth();

  const { user } = useUser();
  const navigate = useNavigate();
  const [showConversationModal, setShowConversationModal] = useState(false);
  const { accountId, accountName, clientName } = useParams();
  const [has_account_access, setHasAccountAccess] = useState(false);
  const [current_benchmark_view, setBenchmarkView] = useState("data");
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  const [activeParentTabKey, setParentActiveTab] = useState("corporateOrg");
  const [createBenchmarkSection, setCreateBenchmarkSection] =
    useState("competitors");
  const [competitorsAvailable, setCompetitorsAvailable] = useState(false);
  const [sidecardTitleBlock, setSidecardTitleBlock] = useState([]);
  const [displayUpdatesSection, setDisplayUpdatesSection] = useState(false);
  const [showFormatDropdown, setShowFormatDropdown] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState(null);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showAiInsights, setShowAiInsights] = useState(false);
  // ++++++++++++++++++++++++++++++++++++++++++
  const [showBenchmarkInfo, setShowBenchmarkInfo] = useState(false);

  const [defaultSelectedCompetitors, setDefaultSelectedCompetitors] = useState(
    []
  );
  const { data: benchmarkGenerationStatusData } = useSelector(
    (state) => state.benchmarkGenerationStatusReducer
  );
  // ++++++++++++++++++++++++++++++++++++++++++

  const exportRef = useRef(null);

  const [benchmarkData, setBenchmarkData] = useState({
    selectedCompetitors: [],
  });

  const resolvedClientName = clientName || accountName;

  const { data: competitorList } = useSelector(
    (state) => state.competitorListReducer
  );

  useEffect(() => {
    if (competitorList && competitorList?.result?.length > 0) {
      setCompetitorsAvailable(true);
    } else {
      setCompetitorsAvailable(false);
    }
  }, [competitorList]);

  useEffect(() => {
    dispatch(
      submitCompetitorListRequest({
        client: resolvedClientName,
        user_id: user?.user_id,
        user_type:
          user?.demo === APP_CONFIG.market_iq_demo ? "MarketIQ" : "CompIQ",
        user_role: user?.growth_iq_role_name,
      })
    );
  }, [resolvedClientName, user, dispatch]);

  useEffect(() => {
    dispatch(
      fetchBenchmarkGenerationStatusRequest({
        client_company: resolvedClientName,
      })
    );

    const interval = setInterval(() => {
      dispatch(
        fetchBenchmarkGenerationStatusRequest({
          client_company: resolvedClientName,
        })
      );
    }, 30000);

    return () => clearInterval(interval);
  }, [resolvedClientName]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (exportRef.current && !exportRef.current.contains(event.target)) {
        setShowFormatDropdown(false);
        setShowExportModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    let titleBlock = "";

    if (createBenchmarkSection === "competitors") {
      titleBlock = (
        <div className="mem-sc-titl-cont justify-content-between">
          <div className="top_head_side_block">
            <div
              className="side_intial_block"
              style={{ backgroundColor: "#7879F1" }}
            >
              <p className="side_intial">A</p>
            </div>

            <div className="top_side_guide">
              <h5 className="top_head_side_guide">Select Competitors</h5>

              <span className="span_memory">
                Create New Competitive Benchmark
              </span>
            </div>
          </div>

          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              setShowMoreModal(false);
            }}
          ></button>
        </div>
      );
    }

    /*
    Existing Sidecard Logic Kept In Comment

    if (createBenchmarkSection === "showSteps") {
      ...
    } else if (createBenchmarkSection === "guidedSelection") {
      ...
    } else if (createBenchmarkSection === "naturalLanguage") {
      ...
    } else if (createBenchmarkSection === "templateUpload") {
      ...
    }
    */

    setSidecardTitleBlock(titleBlock);
  }, [createBenchmarkSection]);

  // +++++++++++++++++++++++++++++++++++++++++++++++++
  const generationStatusList =
    benchmarkGenerationStatusData?.generation_status || [];

  const isBenchmarkGenerating = generationStatusList?.some(
    (item) => item?.generating === true
  );

  useEffect(() => {
    const firstCompletedBenchmark = generationStatusList?.find(
      (item) => item?.generating === false
    );

    if (firstCompletedBenchmark) {
      setDefaultSelectedCompetitors(firstCompletedBenchmark?.competitors || []);
    }
  }, [generationStatusList]);
  // +++++++++++++++++++++++++++++++++++++++++++++++++

  const handleFormatSelect = (format) => {
    setSelectedFormat(format);
    setShowFormatDropdown(false);
    setShowExportModal(true);
  };

  const handleExport = (exportData) => {
    console.log("Export triggered with:", exportData);
    setShowExportModal(false);
  };

  const handleCreateBenchmark = async () => {
    // const payload = {
    //   client_company: resolvedClientName,
    //   competitors: benchmarkData?.selectedCompetitors || [],
    // };

    // dispatch(submitCreateBenchmarkRequest(payload));

    dispatch(
      submitCreateBenchmarkRequest({
        user_id: user?.user_id,
        user_role: user?.growth_iq_role_name,
        user_type:
          user?.demo === APP_CONFIG.market_iq_demo ? "MarketIQ" : "CompIQ",
        client_company: resolvedClientName,
        competitors: benchmarkData?.selectedCompetitors || [],
      })
    );
  };

  const handleExportTemp = async () => {
    let query = { client: "HB Fuller" };

    try {
      const res = await iq_api.get("/export_excel", {
        params: query,
        responseType: "blob",
      });

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");

      a.href = url;
      a.download = "export.xlsx";

      document.body.appendChild(a);

      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (err) {
      console.error("File download failed", err);
    }
  };

  return (
    <div>
      <div className="account_details_wrapper">
        <div className="cardinal_wrapper">
          <div className="cardinal_head_block">
            <div className="cardinal_subblock">
              <h5 className="cardinal_head">
                Competitive Benchmarking - {clientName}
              </h5>

              <p
                style={{
                  fontWeight: "400",
                  fontSize: "12px",
                  lineHeight: "15px",
                  color: "rgba(0, 0, 0, 0.6)",
                  marginTop: "5px",
                  marginBottom: "10px",
                  maxWidth: "100%",
                }}
              >
                Track {clientName ? clientName : ""}'s performance against key
                competitors across financial metrics, market share, and
                strategic positioning.
              </p>
            </div>

            {competitorsAvailable && (
              // <div className="cardinal_btns">
              //   <Button
              //     variant="dark"
              //     className="new_benchmark"
              //     onClick={(e) => {
              //       e.preventDefault();
              //       e.stopPropagation();

              //       setCreateBenchmarkSection("competitors");
              //       setShowMoreModal(true);
              //     }}
              //   >
              //     <img
              //       src="/img/plus.png"
              //       alt="image"
              //       className="filter_image mr-1"
              //       width="16"
              //     />
              //     Create New Benchmark
              //   </Button>
              // </div>

              <div className="cardinal_btns d-flex align-items-center">
                <Button
                  variant="dark"
                  className="new_benchmark"
                  disabled={isBenchmarkGenerating}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    setBenchmarkData({
                      selectedCompetitors: defaultSelectedCompetitors,
                    });

                    setCreateBenchmarkSection("competitors");
                    setShowMoreModal(true);
                  }}
                >
                  <img
                    src="/img/plus.png"
                    alt="image"
                    className="filter_image mr-1"
                    width="16"
                  />

                  {isBenchmarkGenerating
                    ? "Benchmark In Progress"
                    : "Create New Benchmark"}
                </Button>

                {/* <OverlayTrigger
                  trigger="click"
                  placement="bottom"
                  rootClose */}
                {/* <OverlayTrigger
                  trigger="click"
                  placement="bottom"
                  rootClose
                  container={document.body} */}
                <OverlayTrigger
                  trigger="click"
                  placement="bottom-end"
                  rootClose
                  container={document.body}
                  popperConfig={{
                    strategy: "fixed",
                    modifiers: [
                      {
                        name: "preventOverflow",
                        options: {
                          boundary: document.body,
                        },
                      },
                    ],
                  }}
                  // overlay={
                  //   <Tooltip
                  //     id="benchmark-status-tooltip"
                  //     className="benchmark_tooltip_custom"
                  //   >
                  overlay={
                    <Popover
                      id="benchmark-status-tooltip"
                      className="benchmark_status_popover"
                    >
                      <Popover.Body>
                        <div
                          style={{
                            minWidth: "950px",
                            maxHeight: "350px",
                            overflowY: "auto",
                            background: "#fff",
                            color: "#000",
                            padding: "10px",
                          }}
                        >
                          <h6 className="mb-3">Benchmark Generation Status</h6>

                          <Table bordered hover size="sm">
                            <thead>
                              <tr>
                                <th>Competitors</th>
                                <th>Status</th>
                                <th style={{ width: "130px" }}>Created Date</th>
                                {/* <th>Progress</th> */}
                              </tr>
                            </thead>

                            <tbody>
                              {generationStatusList?.length > 0 ? (
                                generationStatusList?.map((item) => (
                                  <tr key={item?._id}>
                                    <td>{item?.competitors?.join(", ")}</td>

                                    <td>
                                      {item?.generating
                                        ? "Generating"
                                        : "Completed"}
                                    </td>
                                    <td>
                                      {displayFormattedDate(
                                        item?.generation_started_at,
                                        "DD-MMM-YYYY"
                                      )}
                                    </td>

                                    {/* <td>
                                    {item?.completed_prompts}/
                                    {item?.total_prompts}
                                  </td> */}
                                  </tr>
                                ))
                              ) : (
                                <>
                                  <tr colspan="3">
                                    <td className="text-center" colspan="3">
                                      No benchmarking records found
                                    </td>
                                  </tr>
                                </>
                              )}
                            </tbody>
                          </Table>
                        </div>
                        {/* </Tooltip> */}
                      </Popover.Body>
                    </Popover>
                  }
                >
                  <div
                    className="ml-2"
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      dispatch(
                        fetchBenchmarkGenerationStatusRequest({
                          client_company: resolvedClientName,
                        })
                      );
                    }}
                  >
                    <FeatherIcon.Info size={18} />
                  </div>
                </OverlayTrigger>
              </div>
            )}
          </div>
        </div>

        <div className="top_tabs_custom">
          <BenchmarkTabs
            displayUpdatesSection={displayUpdatesSection}
            activeParentTabKey={activeParentTabKey}
            setParentActiveTab={setParentActiveTab}
          />
        </div>
      </div>

      <NotifyDropdown
        isOpen={open}
        onClose={() => setOpen(false)}
        anchorRef={buttonRef}
      />

      <GenericOverviewSideCard
        showMoreModal={showMoreModal}
        setShowMoreModal={setShowMoreModal}
        titleForSideCard={sidecardTitleBlock}
        comp={
          createBenchmarkSection === "competitors" ? (
            <CompetitorsNew
              competitorList={competitorList}
              data={benchmarkData}
              updateData={(updatedData) =>
                setBenchmarkData((prev) => ({
                  ...prev,
                  ...updatedData,
                }))
              }
              defaultSelectedCompetitors={defaultSelectedCompetitors}
              showMoreModal={showMoreModal}
              setShowMoreModal={setShowMoreModal}
              onSubmit={handleCreateBenchmark}
              clientName={resolvedClientName}
            />
          ) : (
            <></>
          )

          /*
          Existing Sidecard Comp Logic Kept In Comment

          createBenchmarkSection === "showSteps" ? (
            <AddNewBenchmark
              setCreateBenchmarkSection={setCreateBenchmarkSection}
            />
          ) : createBenchmarkSection === "guidedSelection" ? (
            <WizardContainer />
          ) : createBenchmarkSection === "naturalLanguage" ? (
            <CreateBenchmarkByNaturalLanguage />
          ) : (
            <CreateBenchmarkByTemplateUpload />
          )
          */
        }
        minWidthForDrawer="40%"
        disableXbtn={true}
      />

      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img
                    src="/img/ai_insight_top.png"
                    alt="icon"
                    className="ai_icon"
                  />
                </div>

                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This: Tailored Chemical Products - Market Insights
                  </h5>

                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>

              <div className="ai_insight_right"></div>
            </div>
          }
          comp={<AIChat section={""} />}
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </div>
  );
}
